module.exports = __webpack_public_path__ + "img/book_3.4de31569.jpg";